import { render, staticRenderFns } from "./ExamActionModal.vue?vue&type=template&id=3240925a&scoped=true&"
import script from "./ExamActionModal.vue?vue&type=script&lang=js&"
export * from "./ExamActionModal.vue?vue&type=script&lang=js&"
import style0 from "./ExamActionModal.vue?vue&type=style&index=0&id=3240925a&prod&scoped=true&lang=css&"
import style1 from "./ExamActionModal.vue?vue&type=style&index=1&id=3240925a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240925a",
  null
  
)

export default component.exports